import {EnvironmentImageRequestParams} from "../../models/image/environment-image-request-params";

export class CoverDesktopImageRequestParams extends EnvironmentImageRequestParams {
  constructor() {
    super({});

    this._resourceName = `/background/Cover_Desktop`;
  }
}
